// Conteúdo do aviso de "Novidades" do cabeçalho.
//
// Escrito para quem usa o sistema, não para quem o desenvolve: cada item diz o que muda
// no dia a dia. O que não muda nada para quem usa (refatoração, teste, ajuste interno)
// não entra aqui — uma lista com item que o usuário não reconhece ensina a ignorar o
// aviso inteiro.
//
// Registro impessoal, como manda o design system: o produto nomeia o objeto e o que
// acontece com ele, nunca fala "você". "Todo campo obrigatório passa a mostrar um
// asterisco", não "você agora vê um asterisco". Sem exclamação e sem tom de marketing.
// A regra está travada em useNovidades.spec.js.
//
// Ao anunciar uma leva nova, escreva os itens novos e troque o ID_DAS_NOVIDADES: é ele
// que faz o pontinho vermelho voltar a aparecer para todo mundo. Quem já tinha lido a
// leva anterior volta a ser avisado, e só. Corrigir o texto de uma leva já publicada NÃO
// pede ID novo — avisaria todo mundo de novo por causa de uma vírgula.

export const ID_DAS_NOVIDADES = '2026-09-experiencia'

export const TITULO_DAS_NOVIDADES = 'O que mudou nesta versão'

export const NOVIDADES = [
  {
    icone: 'ph ph-shield-check',
    titulo: 'Formulário preenchido não se perde mais',
    texto:
      'Sair de um formulário com campos preenchidos sem salvar — em Cancelar, na ida para outra tela ou ao fechar a aba — passa a pedir confirmação. Nada é descartado sem ela.'
  },
  {
    icone: 'ph ph-asterisk',
    titulo: 'Campo obrigatório aparece marcado',
    texto:
      'Todo campo obrigatório passa a mostrar um asterisco vermelho no rótulo. O que falta fica visível durante o preenchimento, e não só depois de Salvar.'
  },
  {
    icone: 'ph ph-funnel',
    titulo: 'Painel de filtros mais fácil de operar',
    texto:
      'O topo do painel informa quantos filtros estão preenchidos, e um botão limpa todos de uma vez. O painel também fecha com ESC ou com um clique fora.'
  },
  {
    icone: 'ph ph-keyboard',
    titulo: 'Atalhos de teclado à mostra',
    texto:
      'O botão de teclado no topo lista todos, com busca por tecla ou por nome da ação.'
  },
  // {
  //   icone: 'ph ph-bell-ringing',
  //   titulo: 'Versão nova avisa em vez de recarregar sozinha',
  //   texto:
  //     'Quando sai uma atualização, um aviso aparece no canto e a recarga só acontece depois que ele for aceito. Antes a tela recarregava por conta própria, e o que estava preenchido ia junto.'
  // },
  {
    icone: 'ph ph-browsers',
    titulo: 'Nome da tela no título da aba',
    texto:
      'Com várias abas do sistema abertas, cada uma mostra a tela que está dentro dela. Antes todas diziam apenas "Triveni".'
  },
  {
    icone: 'ph ph-lightning',
    titulo: 'Abre mais rápido',
    texto:
      'O sistema carrega bem menos coisa antes de aparecer na tela, e mostra um sinal de que está carregando em vez de uma tela branca parada.'
  },
  {
    icone: 'ph ph-arrow-u-up-left',
    titulo: 'Tela de erro não prende mais',
    texto:
      'As telas de acesso negado e de página inexistente não ofereciam saída. Agora trazem um botão para voltar à tela anterior e outro para ir ao início.'
  },
  // {
  //   icone: 'ph ph-info',
  //   titulo: 'Versão do sistema visível',
  //   texto:
  //     'O menu do usuário, no canto superior direito, mostra a versão em uso. É a primeira informação que o atendimento pede na abertura de um chamado.'
  // }
]
